import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { OdkAPI } from "../api/endpoints";
import ProjectFormPicker from "../components/ProjectFormPicker";
import { Card, PageHeader, Spinner } from "../components/Layout";

export default function DictionaryPage() {
  const [projectId, setProjectId] = useState<number | null>(null);
  const [formId, setFormId] = useState<string | null>(null);
  const [filter, setFilter] = useState("");

  const q = useQuery({
    queryKey: ["variables", projectId, formId],
    queryFn: () => OdkAPI.variables(projectId!, formId!),
    enabled: !!projectId && !!formId,
  });

  const rows = (q.data ?? []).filter(
    (v) =>
      !filter ||
      v.name.toLowerCase().includes(filter.toLowerCase()) ||
      (v.label ?? "").toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="p-4 sm:p-6 max-w-6xl mx-auto">
      <PageHeader title="Diccionario de variables" subtitle="Etiquetas y tipos por formulario (desde el XLSForm)." />
      <Card className="mb-4">
        <ProjectFormPicker
          projectId={projectId}
          formId={formId}
          onProject={(id) => { setProjectId(id); setFormId(null); }}
          onForm={setFormId}
        />
      </Card>

      {formId && (
        <Card>
          <div className="flex items-center justify-between mb-3">
            <input
              placeholder="Filtrar…"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="input w-full sm:w-64"
            />
            <div className="text-xs text-tinta-3">{rows.length} variables</div>
          </div>
          {q.isLoading && <Spinner />}
          {q.error && <div className="text-estado-critico text-sm">Error al cargar el diccionario.</div>}
          <div className="overflow-auto max-h-[60vh]">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-left text-tinta-3 border-b border-grid">
                  <tr>
                    <th className="py-2 pr-3">Variable</th>
                    <th className="py-2 pr-3">Etiqueta</th>
                    <th className="py-2 pr-3">Tipo</th>
                    <th className="py-2 pr-3">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((v) => (
                    <tr key={v.name} className="border-b border-grid">
                      <td className="py-2 pr-3 font-mono text-marca">{v.name}</td>
                      <td className="py-2 pr-3">{v.label}</td>
                      <td className="py-2 pr-3 text-xs text-tinta-3">{v.type}</td>
                      <td className="py-2 pr-3 text-xs text-tinta-3">
                        {v.choices ? Object.entries(v.choices).map(([k, val]) => `${k}=${val}`).join(", ") : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
}
